<template>
    <v-card class="elevation-2" style="margin-top: 20px;">
        <v-card-title>
            <v-icon left>mdi-gavel</v-icon>
            Legal Attestation Required
        </v-card-title>

        <v-card-text>
            <v-alert type="info" style="margin-bottom: 20px;">
                <strong>Legal Requirement:</strong> You must attest that you have proper legal authority to import these
                records. <strong>There is no rollback or undo available after submitting this import.</strong>
            </v-alert>

            <div style="margin-bottom: 20px;">
                <h4>Import Summary</h4>
                <v-row>
                    <v-col v-for="summary in summaryItems" :key="summary.key" :cols="summary.cols || 6">
                        <strong>{{ summary.label }}:</strong> {{ getSummaryValue(summary.key, summary.formatter) }}
                    </v-col>
                </v-row>
            </div>

            <v-divider style="margin: 20px 0;"></v-divider>

            <div style="margin-bottom: 20px;">
                <h4>Legal Attestation</h4>
                <p>By proceeding with this import, you attest that:</p>
                <ul style="margin-left: 20px; margin-bottom: 15px;">
                    <li v-for="requirement in legalRequirements" :key="requirement">
                        {{ requirement }}
                    </li>
                </ul>
            </div>

            <v-checkbox v-model="attestationChecked" color="primary" style="margin-bottom: 15px;">
                <template slot="label">
                    <span>{{ attestationText }}</span>
                </template>
            </v-checkbox>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'import-legal-attestation',

    props: {
        previewData: {
            type: Object,
            required: true
        },
        importId: {
            type: String,
            required: true
        },
        processing: {
            type: Boolean,
            default: false
        },
        summaryItems: {
            type: Array,
            default: () => [
                { key: 'total_records', label: 'Total Records', cols: 6 },

            ]
        },
        legalRequirements: {
            type: Array,
            default: () => [
                'You have proper legal authority to import these records',
                'All records were obtained in compliance with applicable laws',
                'You have verified the accuracy of the information',
                'You understand this action will update the system data'
            ]
        },
        attestationText: {
            type: String,
            required: true
        },
        organizationLabel: {
            type: String,
            default: 'your organization'
        },

        // Optional route to navigate to when canceling import
        // If not provided, will emit 'cancel' event for parent to handle
        cancelRoute: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            attestationChecked: false,
        };
    },

    computed: {
        canProceed() {
            return this.attestationChecked &&
                this.validRecords > 0;
        },

        validRecords() {
            return this.previewData?.valid_records_count || 0;
        }
    },

    watch: {
        attestationChecked(newValue) {
            this.$emit('attestation-changed', newValue);
        }
    },

    methods: {
        getSummaryValue(key, formatter) {
            const value = this.previewData?.[key] || 0;

            if (formatter && typeof formatter === 'function') {
                return formatter(value, this.previewData);
            }

            return value;
        },

        onCancel() {
            // Use RedChirp confirmation dialog
            this.$rc.confirm({
                title: 'Cancel Import',
                body: 'Are you sure you want to cancel this import? This action cannot be undone and the import will be marked as cancelled.',
                btn_text_ok: 'Yes, Cancel Import',
                btn_text_cancel: 'Keep Import',
                on_ok: () => {
                    this.cancelImport();
                }
            });
        },

        cancelImport() {
            this.$emit('cancel');

        },

        onProceed() {
            const attestationData = {
                attestation_confirmed: true,
                attestation_timestamp: new Date().toISOString(),
                organization_label: this.organizationLabel,
                attestation_text: this.attestationText // Include the checkbox text that was agreed to
            };

            this.$emit('proceed', attestationData);
        },
    }
};
</script>
